import IoTSvgImg from "@assets/images/representation-of-internet-of-things.webp";
import { motion } from "framer-motion";
import { TiTick } from "react-icons/ti";

export const IoTSolution = () => {
  return ( 
    <section className="container">
      <div className="flex flex-col space-y-10">
        <div className="text-center space-y-5">

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
          className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px] font-bold   text-dark text-start font-butler "
        >
          IoT Solutions for Innovators{" "}
        </motion.h2>
         <div className="space-y-3">

            <p className="text-base leading-[1.625rem]  font-semibold text-dark text-start ">
              We empower small businesses and solopreneurs to prototype and
              scale innovative IoT solutions. We understand that for a
              non-technical founder, the biggest risks aren't just in the code,
              but in Intellectual Property (IP) ownership, manufacturing costs,
              and long-term maintenance.
            </p>
            <p className="text-base leading-[1.625rem] font-semibold text-dark text-start ">
              Our mission is to help you ideate and implement robust IoT
              solutions for both conventional and emerging use-cases through a
              transparent, modular process. Whether you are building an IoT app
              for a new consumer gadget or a complex monitoring solution for
              industry, we ensure you maintain full control of your source code
              and hardware blueprints.
            </p>
          </div>
          </div>
        <div className="flex flex-col lg:flex-row justify-center items-center space-y-10 lg:space-y-0  lg:space-x-8 sm:px-10   lg:px-0 ">
          <div className="space-y-10 w-full lg:w-8/12 ">
         
            <ul className="space-y-5 lg:space-y-2 text-lg px-2 md:px-0">
              <li className="flex items-start text-dark  space-x-2">
                <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-0.5">
                  <TiTick />
                </span>

                <div className="">
                  <span className="inline font-bold m-0 text-lg">
                    Risk-free Prototyping:{" "}
                  </span>{" "}  
                  <span className="text-base leading-[1.625rem]">
                    We move your idea to a tangible prototype smart device using
                    a lean methodology that validates your business model before
                    heavy investment.
                  </span>
                </div>
              </li>
              <li className="flex items-start text-dark space-x-2">
                <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-0.5">
                  <TiTick />
                </span>

                <div className="">
                  <h3 className="inline font-bold m-0 text-lg">IP Transparency: </h3>{" "}
                  <span className="text-base leading-[1.625rem]">
                    Unlike many agencies, we guarantee that you own every line
                    of IoT software and every PCB layout we create.
                  </span>
                </div>
              </li>
              <li className="flex items-start text-dark text-base md:text-lg space-x-2">
                <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-0.5">
                  <TiTick />
                </span>

                <div className="">
                  <h3 className="inline font-bold m-0 text-lg">
                    Bridge to Manufacturing:{" "}
                  </h3>{" "}
                  <span className="text-base leading-[1.625rem]">
                    We don't just build a Minimal Viable Product or present a
                    Proof of Concept; we prepare your product for real-world
                    production, helping you navigate the jump from Raspberry Pi
                    and Arduino to custom microcontrollers.
                  </span>
                </div>
              </li>
            </ul>
          </div>
          <div className="w-full lg:w-4/12 flex   justify-center items-start xl:items-center ">
            <img
              src={IoTSvgImg}
              alt="A UI/UX design of a mobile application with prototyping connections showing user flow."
              className="rounded  w-8/12 md:w-6/12 lg:w-9/12 h-auto "
            />
          </div>
        </div>
      </div>
    </section>
  );
};
